import { render, staticRenderFns } from "./Center.vue?vue&type=template&id=81b45454&scoped=true&functional=true&"
var script = {}
import style0 from "./Center.vue?vue&type=style&index=0&id=81b45454&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "81b45454",
  null
  
)

export default component.exports